import React from "react";

export const ContactIcon = (props) => {
  return (
    <>
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx={12}
          cy={12}
          r={11}
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M10.6719 15.505V15.3835C10.6804 14.5909 10.7592 13.9602 10.9084 13.4915C11.0618 13.0227 11.2791 12.6435 11.5604 12.3537C11.8416 12.0639 12.1804 11.7997 12.5767 11.5611C12.8324 11.3991 13.0625 11.218 13.267 11.0178C13.4716 10.8175 13.6335 10.5874 13.7528 10.3274C13.8722 10.0675 13.9318 9.77983 13.9318 9.46449C13.9318 9.08523 13.8423 8.7571 13.6634 8.48011C13.4844 8.20312 13.2457 7.99006 12.9474 7.84091C12.6534 7.6875 12.3253 7.6108 11.9631 7.6108C11.6349 7.6108 11.3217 7.67898 11.0234 7.81534C10.7251 7.95171 10.478 8.16477 10.282 8.45455C10.0859 8.74006 9.97301 9.10866 9.94318 9.56037H8C8.02983 8.79332 8.22372 8.1456 8.58168 7.61719C8.93963 7.08452 9.41264 6.68182 10.0007 6.40909C10.593 6.13636 11.2472 6 11.9631 6C12.7472 6 13.4332 6.14702 14.0213 6.44105C14.6094 6.73082 15.0653 7.13778 15.3892 7.66193C15.7173 8.18182 15.8814 8.78906 15.8814 9.48366C15.8814 9.96094 15.8068 10.3913 15.6577 10.7749C15.5085 11.1541 15.2955 11.4929 15.0185 11.7912C14.7457 12.0895 14.4176 12.3537 14.0341 12.5838C13.6719 12.8097 13.3778 13.044 13.152 13.2869C12.9304 13.5298 12.7685 13.8175 12.6662 14.1499C12.5639 14.4822 12.5085 14.8935 12.5 15.3835V15.505H10.6719ZM11.6371 19.3913C11.2876 19.3913 10.9872 19.2678 10.7358 19.0206C10.4844 18.7692 10.3587 18.4666 10.3587 18.1129C10.3587 17.7635 10.4844 17.4652 10.7358 17.218C10.9872 16.9666 11.2876 16.8409 11.6371 16.8409C11.9822 16.8409 12.2805 16.9666 12.532 17.218C12.7876 17.4652 12.9155 17.7635 12.9155 18.1129C12.9155 18.3473 12.8558 18.5625 12.7365 18.7585C12.6214 18.9503 12.468 19.1037 12.2763 19.2188C12.0845 19.3338 11.8714 19.3913 11.6371 19.3913Z"
          fill="white"
          style={{
            fill: "white",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
